module.exports = __webpack_public_path__ + "static/media/upload-preparetion.f8541ab3.svg";